import React, { memo, ReactNode, useMemo, useState } from 'react';
import { R } from '@core/utils/r';
import { UncontrolledTooltip } from 'reactstrap';
import { CommonService } from '@business/services';
const COLORS = ['info', 'primary', 'success', 'dark', 'secondary', 'warning', 'pink'];

export interface AvatarGroupItem {
  id: string;
  title: string;
}
export interface AvatarGroupProps {
  items: AvatarGroupItem[];
  onClick?(item: AvatarGroupItem, index: number): void;
  sort?: boolean;
  onTooltip?(item: AvatarGroupItem, index: number): ReactNode | string;
  hideTooltip?: boolean;
  baseId?: string;
  overlap?: boolean;
  children?: ReactNode;
  size?: number;
  onRemove?(user: AvatarGroupItem, index: number): void;
  tooltipContainer?: string;
  viewOnly?: boolean;
  tooltipText?: string;
}

export const AvatarGroup = memo((props: AvatarGroupProps) => {
  const { onClick, sort, onTooltip, hideTooltip = false, overlap = false, size = 3, onRemove, viewOnly, tooltipText = '' } = props;
  const [activeItem, setActiveItem] = useState(-1);
  const canRemove = useMemo(() => !viewOnly, [viewOnly]);
  const items = useMemo(() => {
    if (sort) {
      return R.sortBy(props.items, item => item.title);
    }
    return props.items;
  }, [sort, props.items]);

  const baseId = useMemo(() => {
    return props.baseId || R.random(100, 5000).toString();
  }, [props.baseId]);

  return (
    <div className="avatar-group ml-2">
      {items.map((item, index) => (
        <div
          onClick={() => onClick && onClick(item, index)}
          className="avatar-group-item"
          style={{ marginLeft: overlap ? `-${size / 4}rem` : 'initial', zIndex: index === activeItem ? items.length + 2 : items.length - index }}
          key={'_avatar_' + baseId + item.id}
        >
          <a className="d-inline-block" id={'user_item' + baseId + item.id}>
            <div
              onMouseOver={() => setActiveItem(index)}
              onMouseLeave={() => setActiveItem(-1)}
              className="avatar-md"
              style={{ width: size + 'rem', height: size + 'rem' }}
            >
              {activeItem === index && !!onRemove && canRemove && (
                <a className="btn-avatar-close" onClick={() => onRemove(item, index)}>
                  <i className="fas fa-times text-white font-size-10"></i>
                </a>
              )}
              <span
                className={`avatar-title rounded-circle bg-${COLORS[index % COLORS.length]} text-white ${
                  size == 3 ? 'font-size-16' : 'font-size-12'
                }`}
              >
                {CommonService.getShortNameFromString(item.title)}
              </span>

              {!hideTooltip && (
                <UncontrolledTooltip container={props.tooltipContainer} placement="top" target={'user_item' + baseId + item.id}>
                  {onTooltip ? onTooltip(item, index) : `${tooltipText}${item.title}`}
                </UncontrolledTooltip>
              )}
            </div>
          </a>
        </div>
      ))}

      {props.children}
    </div>
  );
});
